var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", { staticClass: "main page home" }, [
    _c("div", { staticClass: "header__section" }, [
      _c("div", { staticClass: "column home__header" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm.basicPage && _vm.basicPage.body && _vm.basicPage.body.length
              ? _c("TitleBlock", {
                  attrs: {
                    text: "New! Vixio Workspace",
                    color: "brightgreen",
                    padding: false,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.basicPage && _vm.basicPage.body && _vm.basicPage.body.length
              ? _c("TextContent", { attrs: { content: _vm.basicPage.body } })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [_c("ChecklistOverview", { staticClass: "column" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "column column--2-3" }, [
          _vm.featured && _vm.featured.length
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom feat_cont",
                },
                [
                  _c("TitleBlock", {
                    attrs: { text: "Featured", color: "corporateblue" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    _vm._l(_vm.featured.slice(0, 3), function (article, index) {
                      return _c(
                        "el-col",
                        {
                          key: article.key,
                          attrs: { sm: 24, md: index === 0 ? 24 : 12 },
                        },
                        [
                          _c("ArticleVx", {
                            class: { "bot-line": index === 0 },
                            attrs: {
                              title: article.title,
                              desc: article.summary,
                              date: article.publishedDate,
                              size: null,
                              link: article.url,
                              tags: article.tags,
                              "watchlist-tags": _vm.watchlistTags,
                              author: article.author,
                              "has-access": _vm.hasAccessArticle,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.recommended && _vm.recommended.length
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom",
                },
                [
                  _c("TitleBlock", {
                    attrs: {
                      text: "Recommended for you",
                      color: "corporateblue",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    _vm._l(_vm.recommended, function (article, index) {
                      return _c(
                        "el-col",
                        { key: article.key, attrs: { sm: 24, md: 12 } },
                        [
                          _c("ArticleVx", {
                            class: { "bot-line": index < 2 },
                            attrs: {
                              title: article.title,
                              desc: article.summary,
                              date: article.publishedDate,
                              size: null,
                              link: article.url,
                              tags: article.tags,
                              author: article.author,
                              "watchlist-tags": _vm.watchlistTags,
                              "has-access": _vm.hasAccessArticle,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkMapAccess() &&
          !_vm.mapData.forbidden &&
          _vm.featured &&
          _vm.featured.length
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom",
                  staticStyle: { "padding-right": "0rem" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: { position: "relative", height: "600px" },
                      attrs: { id: "hs-map-block" },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            position: "relative",
                            height: "600px",
                            width: "100%",
                            "margin-top": "-56px",
                          },
                        },
                        [_c("HsMap", { attrs: { "map-data": _vm.mapData } })],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.regulatoryAnalysis && _vm.regulatoryAnalysis.length
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom",
                },
                [
                  _c("TitleBlock", {
                    attrs: {
                      text: "Regulatory Analysis",
                      color: "corporateblue",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    _vm._l(
                      _vm.regulatoryAnalysis.slice(0, 2),
                      function (article) {
                        return _c(
                          "el-col",
                          { key: article.key, attrs: { sm: 24, md: 12 } },
                          [
                            _c("ArticleVx", {
                              attrs: {
                                title: article.title,
                                desc: article.summary,
                                date: article.publishedDate,
                                size: null,
                                link: article.url,
                                tags: article.tags,
                                author: article.author,
                                "watchlist-tags": _vm.watchlistTags,
                                "has-access": _vm.hasAccessArticle,
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.guides.forbidden || (_vm.guides && _vm.guides.length)
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom",
                },
                [
                  _c("TitleBlock", {
                    attrs: { text: "Reports", color: "corporateblue" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "guides-container" },
                    _vm._l(_vm.guides.slice(0, 4), function (article, index) {
                      return _c(
                        "div",
                        {
                          key: article.key,
                          staticClass: "area",
                          class: `area-${index + 1}`,
                        },
                        [
                          _c("Guide", {
                            attrs: {
                              title: article.title,
                              desc:
                                index === 0 && index === 3
                                  ? article.summary
                                  : null,
                              date: article.publishedDate,
                              link: article.relativeLink,
                              author: article.author,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.insights && _vm.insights.length
            ? _c(
                "div",
                {
                  staticClass:
                    "main__featured section section-border--top section-border--right section-border--bottom",
                },
                [
                  _c("TitleBlock", {
                    attrs: { text: "Insights", color: "corporateblue" },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    _vm._l(_vm.insights, function (article, index) {
                      return _c(
                        "el-col",
                        { key: article.key, attrs: { sm: 24, md: 12 } },
                        [
                          _c("ArticleVx", {
                            class: { "bot-line": index < 4 },
                            attrs: {
                              title: article.title,
                              desc: index < 2 ? article.summary : null,
                              date: article.publishedDate,
                              size: index > 1 ? "small" : null,
                              link: article.url,
                              author: article.author,
                              tags: article.tags,
                              "has-access": _vm.hasAccessArticle,
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column column--1-3" }, [
          _c(
            "div",
            { staticClass: "main__sidebar" },
            [
              _vm.hasHSAccess &&
              _vm.weekCount &&
              _vm.weekCount.watchlistJurisdictions
                ? _c("HsUpdates", [
                    _c("div", { staticClass: "main__vixio" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "main__vixio-list section-border--top section-border--right section-border--bottom",
                        },
                        [
                          _c("div", { staticClass: "hsupdates" }, [
                            _c("div", [
                              _c("img", {
                                staticClass: "hsupdates__icon",
                                attrs: {
                                  height: "24",
                                  width: "24",
                                  src: require("../../assets/icons/globe.svg"),
                                  alt: "globe",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "hsupdates__total" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dataUser.daysSincePreviousLogin <= 7 &&
                                    _vm.dataUser.daysSincePreviousLogin !== null
                                    ? _vm.weekCount?.hsUpdates?.totalHsUpdates
                                    : _vm.fortnightCount?.hsUpdates
                                        ?.totalHsUpdates
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.dataUser.daysSincePreviousLogin <= 7 &&
                            _vm.dataUser.daysSincePreviousLogin !== null
                              ? _c(
                                  "div",
                                  { staticClass: "hsupdates__description" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.weekCount.hsUpdates
                                            .totalHsUpdates == 0
                                            ? "No "
                                            : ""
                                        ) +
                                        "Horizon Scanning updates for your Watchlists in the last 7 days\n                  "
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "hsupdates__description" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.fortnightCount.hsUpdates
                                            .totalHsUpdates == 0
                                            ? "No "
                                            : ""
                                        ) +
                                        "Horizon Scanning updates for your Watchlists in the last 14 days\n                  "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__actionable" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Actionable",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5267"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Actionable:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalActionable
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalActionable
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__indicative" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Indicative",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5268"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Indicative:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalIndicative
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalIndicative
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__informative" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Informative",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5269"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Informative:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalInformative
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalInformative
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__viewlatest" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hsupdates__viewlatest-link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "View Latest Updates",
                                          "regulatory_updates"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("View Latest Updates")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasHSAccess &&
              _vm.weekCount &&
              !_vm.weekCount.watchlistJurisdictions
                ? _c("HsUpdates", [
                    _c("div", { staticClass: "main__vixio" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "main__vixio-list section-border--top section-border--right section-border--bottom",
                        },
                        [
                          _c("div", { staticClass: "hsupdates" }, [
                            _c("div", [
                              _c("img", {
                                staticClass: "hsupdates__icon",
                                attrs: {
                                  height: "24",
                                  width: "24",
                                  src: require("../../assets/icons/globe.svg"),
                                  alt: "globe",
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "hsupdates__total" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dataUser.daysSincePreviousLogin <= 7 &&
                                    _vm.dataUser.daysSincePreviousLogin !== null
                                    ? _vm.weekCount?.hsUpdates?.totalHsUpdates
                                    : _vm.fortnightCount?.hsUpdates
                                        ?.totalHsUpdates
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.dataUser.daysSincePreviousLogin <= 7 &&
                            _vm.dataUser.daysSincePreviousLogin !== null
                              ? _c(
                                  "div",
                                  { staticClass: "hsupdates__description" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.weekCount.hsUpdates
                                            .totalHsUpdates == 0
                                            ? "No "
                                            : ""
                                        ) +
                                        "Horizon Scanning updates for your jurisdictions in the last 7 days\n                  "
                                    ),
                                  ]
                                )
                              : _c(
                                  "div",
                                  { staticClass: "hsupdates__description" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.fortnightCount.hsUpdates
                                            .totalHsUpdates == 0
                                            ? "No "
                                            : ""
                                        ) +
                                        "Horizon Scanning updates for your jurisdictions in the last 14 days\n                  "
                                    ),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__actionable" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Actionable",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5267"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Actionable:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalActionable
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalActionable
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__indicative" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Indicative",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5268"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Indicative:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalIndicative
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalIndicative
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__informative" },
                              [
                                _c(
                                  "div",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "Informative",
                                          "search?source=hsblock&tab=3&filter%5Bclassifications%5D%5B%5D=5269"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Informative:")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "count" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dataUser.daysSincePreviousLogin <=
                                        7 &&
                                        _vm.dataUser.daysSincePreviousLogin !==
                                          null
                                        ? _vm.weekCount?.hsUpdates
                                            ?.totalInformative
                                        : _vm.fortnightCount?.hsUpdates
                                            ?.totalInformative
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "hsupdates__viewlatest" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "hsupdates__viewlatest-link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.trackCategoryClicked(
                                          "View Latest Updates",
                                          "regulatory_updates"
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("View Latest Updates")]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "Sidebar",
                {
                  staticClass: "test",
                  attrs: { "props-handle-click-close": _vm.toggleSidebar },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.picks && _vm.picks.length,
                          expression: "picks && picks.length",
                        },
                      ],
                      staticClass: "main__vixio",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "main__vixio-list section-border--top section-border--right section-border--bottom",
                        },
                        [
                          _c("TitleBlock", {
                            attrs: {
                              text: "VIXIO Picks",
                              color: "corporateblue",
                            },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.picks, function (item, index) {
                            return _c("MustRead", {
                              key: index,
                              attrs: {
                                text: item.title,
                                number: index + 1,
                                link: item.url,
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "main__hots" }, [
                    _c("div", { staticClass: "main__hots-title" }, [
                      _vm._v("WATCHLIST TRENDING"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "main__hots-content section section-border--top section-border--right section-border--bottom",
                      },
                      _vm._l(_vm.hot, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "main__hots-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "main__hots-subtitle" },
                              [_c("Tag", { attrs: { text: item.name } })],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(item.children, function (range, index2) {
                              return _c("Range", {
                                key: index2,
                                attrs: {
                                  text: range.name,
                                  width: range.weight,
                                  range: range,
                                  category: item.tid,
                                  tid: range.tid,
                                  jurisdiction: item.tid,
                                  type: range.vid,
                                },
                              })
                            }),
                            _vm._v(" "),
                            _c("script"),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "main__hots" }, [
                    _c("div", { staticClass: "main__hots-title" }, [
                      _vm._v("GLOBAL TRENDING"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "main__hots-content section section-border--top section-border--right section-border--bottom",
                      },
                      _vm._l(_vm.hotGlobal, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "main__hots-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "main__hots-subtitle" },
                              [_c("Tag", { attrs: { text: item.name } })],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(item.children, function (range, index2) {
                              return _c("Range", {
                                key: index2,
                                attrs: {
                                  text: range.name,
                                  width: range.weight,
                                  link: range,
                                  category: item.tid,
                                  tid: range.tid,
                                  jurisdiction: item.tid,
                                  type: range.vid,
                                },
                              })
                            }),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "title-block title-block__size--default title-block__color--gold title-spacing",
        staticStyle: { position: "relative", width: "100%", "z-index": "999" },
      },
      [
        _c("h2", { staticClass: "title-block__text" }, [
          _vm._v("HORIZON SCANNING"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }